import SlideoutMenu from '@orn/shared-web/components/SlideoutMenu';
import { DollarIcon } from '@orn/shared-web/icons';

import { toCurrency } from '../../../utils/formatting';
import { calculateYearlySpend } from '../../../utils/recurring';

import type { RecurringTransactionFrequency } from '../../../__generated__/globalTypes';

interface IYearlySpendRowProps {
  amountRange?: string[];
  frequency?: RecurringTransactionFrequency;
}

const YearlySpendRow = ({ amountRange, frequency }: IYearlySpendRowProps) => {
  if (!amountRange || !frequency) {
    return null;
  }

  const yearlySpend = calculateYearlySpend(amountRange, frequency);

  return (
    <SlideoutMenu.Row icon={<DollarIcon className="size-4.5 shrink-0" />} title="Yearly spend">
      <div className="flex flex-col items-end">
        <div className="text-primary text-md font-medium">{toCurrency(yearlySpend)}</div>
        <div className="text-tertiary text-sm font-normal italic">Estimated</div>
      </div>
    </SlideoutMenu.Row>
  );
};

export default YearlySpendRow;
